module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/provider/provider-approval.component.css
// module id = ./src/app/views/provider/provider-approval.component.css
// module chunks = main